import { render } from "./file.vue?vue&type=template&id=a503410c&scoped=true"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"

import "./file.vue?vue&type=style&index=0&id=a503410c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a503410c"],['__file',"src/components/scUpload/file.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a503410c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a503410c', __exports__)) {
    api.reload('a503410c', __exports__)
  }
  
  module.hot.accept("./file.vue?vue&type=template&id=a503410c&scoped=true", () => {
    api.rerender('a503410c', render)
  })

}


export default __exports__